import React, { Component } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import Template from './template'
import ScrollTop from './element/scroll-top/scroll-top'
import NotFound from './element/not-found/not-found'
import PromotionDetail from './components/promotion/promotion-detail'
import ProductDetail from './components/product/product-detail'
import ContactDetail from './components/contact/contact-detail'
import './App.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faClock,
  faPhone,
  faUsers,
  faHotdog,
  faBullhorn,
  faMapMarkedAlt,
  faEnvelope,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons'
import AOS from 'aos'
import 'aos/dist/aos.css'

library.add(
  faClock,
  faPhone,
  faUsers,
  faHotdog,
  faBullhorn,
  faMapMarkedAlt,
  faEnvelope,
  faChevronLeft,
  faChevronRight
)
AOS.init()

class App extends Component {
  render() {
    return (
      <Router>
        <ScrollTop />
        <Switch>
          <Route exact path="/" component={Template} />
          <Route exact path="/promotion-detail" component={PromotionDetail} />
          <Route exact path="/product-detail" component={ProductDetail} />
          <Route exact path="/contact-detail" component={ContactDetail} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    )
  }
}

export default App
